import { DestroyRef, inject, signal, type Signal } from '@angular/core';

export function useNetworkStatus(): { online: Signal<boolean> } {
    const online = signal(navigator.onLine);

    const setOnline = () => online.set(true);
    const setOffline = () => online.set(false);

    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);

    inject(DestroyRef).onDestroy(() => {
        window.removeEventListener('online', setOnline);
        window.removeEventListener('offline', setOffline);
    });

    return { online: online.asReadonly() };
}
